import { createSelector } from 'reselect';
import { RootState } from 'src/store';
import { deriveSkuKey } from 'src/util/skuKey';

const getSceneSku = (state: RootState) => {
    const { sku, skuVersion, merchantSku, merchantVersion } = state.pages.editor.surfaces;
    return deriveSkuKey({ sku, skuVersion, merchantSku, merchantVersion });
};

const getSku = createSelector([getSceneSku], (sku) => sku);

export default getSku;
